import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "componentNameInput",
    "kindInput",
    "wrapperCheckboxFrame",
    "componentNameFrame",
  ];
  connect() {}

  refresh() {
    const kind = this.hasKindInputTarget
      ? encodeURIComponent(this.kindInputTarget.value)
      : "";
    const componentName = this.hasComponentNameInputTarget
      ? encodeURIComponent(this.componentNameInputTarget.value)
      : "";
    const src = `${window.location.href}${window.location.href.includes("?") ? "&" : "?"}kind=${kind}&component_name=${componentName}`;
    this.wrapperCheckboxFrameTarget.src = src;
    this.componentNameFrameTarget.src = src;
  }
}
